import { env } from 'env';

const { REACT_APP_CLIENT_ENV = 'Common' } = env;

export enum LanguageNamespaces {
  Common = 'common',
  EK = 'ek',
}

const NAMESPACE_MAP: { [key: string]: LanguageNamespaces } = {
  Common: LanguageNamespaces.Common,
  EK: LanguageNamespaces.EK,
};

export const LANGUAGE_NAMESPACE =
  NAMESPACE_MAP[REACT_APP_CLIENT_ENV] || LanguageNamespaces.Common;

export enum LanguageCodes {
  En = 'en',
  Es = 'es',
  Pt = 'pt',
  Fr = 'fr',
  De = 'de',
  Nl = 'nl',
  Dk = 'da',
  Se = 'sv',
  No = 'no',
  Ru = 'ru',
  Pl = 'pl',
  It = 'it',
  Cz = 'cs',
  Ro = 'ro',
  Fi = 'fi',
  Is = 'is',
  Tr = 'tr',
  Gb = 'cy',
  Arb = 'ar',
  Cn = 'zh-CN',
  In = 'hi',
  Jp = 'ja',
  Kr = 'ko',
}

export const POLLY_TO_LANGUAGE_CODE: Record<string, string> = {
  arb: LanguageCodes.Arb,
  cn: LanguageCodes.Cn,
  cz: LanguageCodes.Cz,
  dk: LanguageCodes.Dk,
  in: LanguageCodes.In,
  jp: LanguageCodes.Jp,
  kr: LanguageCodes.Kr,
  se: LanguageCodes.Se,
  gb: LanguageCodes.Gb,
};

export const LANGUAGE_CODE_TO_POLLY: Record<string, string> = Object.fromEntries(
  Object.entries(POLLY_TO_LANGUAGE_CODE).map(([pollyCode, languageCode]) => [
    languageCode.toLowerCase(),
    pollyCode,
  ]),
);

export const toPollyLanguageCode = (languageCode: string): string => {
  const lower = languageCode.toLowerCase();
  return LANGUAGE_CODE_TO_POLLY[lower] ?? lower;
};

export const LANGUAGES = [
  { key: LanguageCodes.En, label: 'English' },
  { key: LanguageCodes.Es, label: 'Español' },
  { key: LanguageCodes.Pt, label: 'Português' },
  { key: LanguageCodes.Fr, label: 'Français' },
  { key: LanguageCodes.De, label: 'Deutsch' },
  { key: LanguageCodes.Nl, label: 'Nederlands' },
  { key: LanguageCodes.Dk, label: 'Dansk' },
  { key: LanguageCodes.Se, label: 'Svenska' },
  { key: LanguageCodes.No, label: 'Norsk' },
  { key: LanguageCodes.Ru, label: 'Русский' },
  { key: LanguageCodes.Pl, label: 'Polski' },
  { key: LanguageCodes.It, label: 'Italiano' },
  { key: LanguageCodes.Cz, label: 'Čeština' },
  { key: LanguageCodes.Ro, label: 'Română' },
  { key: LanguageCodes.Fi, label: 'Suomi' },
  { key: LanguageCodes.Is, label: 'Íslenska' },
  { key: LanguageCodes.Tr, label: 'Türkçe' },
  { key: LanguageCodes.Gb, label: 'Cymraeg' },
  { key: LanguageCodes.Arb, label: 'العربية' },
  { key: LanguageCodes.Cn, label: '中文' },
  { key: LanguageCodes.In, label: 'हिन्दी' },
  { key: LanguageCodes.Jp, label: '日本語' },
  { key: LanguageCodes.Kr, label: '한국어' },
];
